import { useContext, useEffect, useState } from "react";
import icon_delete from "../assets/icons/icon-delete.svg";
import icon_edit from "../assets/icons/icon-edit.svg";
import { TodosContext } from "../pages/ItemDetail";
import DeleteItem from "./DeleteItem";
import TodoEmpty from "./TodoEmpty";
function ListItems() {
  const {
    todosItem,
    priorities,
    handleModalDeleteToggle,
    setDeleteTodoItem,
    handleModalToggle,
    setUpdateTodoItem,
    resetItemDelete,
    deleteTodoItem,
    deleteTodo,
    isDelete,
    updateTodo,
  } = useContext(TodosContext);
  const [todos, setTodos] = useState([]);

  const handleToggle = (item) => {
    const active = item.is_active ? 0 : 1;
    const data = {
      is_active: active,
      value: active,
      key: item.id,
    };
    setTodos(
      [...todos].map((todo) =>
        todo.id === item.id ? { ...todo, is_active: data.is_active } : todo
      )
    );
    updateTodo(item.id, data);
  };

  const handleEdit = (data) => {
    setUpdateTodoItem(data);
    handleModalToggle();
  };

  const setDeleteTodo = (data) => {
    setDeleteTodoItem(data);
    handleModalDeleteToggle();
  };

  const handleBack = () => {
    handleModalDeleteToggle();
    resetItemDelete();
  };
  const handleDelete = () => {
    deleteTodo();
  };

  useEffect(() => {
    setTodos([...todosItem]);
  }, [todosItem]);

  return (
    <>
      <div className="list-disc pl-4 mt-[50px]">
        {todos.length > 0 ? (
          todos.map((todo, index) => (
            <div
              data-cy={`todo-item-${index}`}
              key={todo.id}
              className={`flex flex-row items-center rounded-md shadow-md w-full h-[80px] gap-[20px] px-[20px]`}
            >
              <input
                data-cy="todo-item-checkbox"
                type="checkbox"
                checked={todo.is_active === 0}
                onChange={() => handleToggle(todo)}
                className="form-checkbox h-5 w-5 text-red-500"
              />
              {priorities.map((priority) => {
                return (
                  todo.priority === priority.value && (
                    <div
                      key={priority.value}
                      className={`w-[14px] h-[14px] rounded-full bg-[${priority.color}]`}
                    ></div>
                  )
                );
              })}

              <div className="flex flex-row">
                <span
                  data-cy="todo-item-title"
                  className={
                    todo.is_active ? "text-sans line-through text-gray-500" : ""
                  }
                >
                  {todo.title}
                </span>
                <img
                  data-cy="todo-item-edit-button"
                  onClick={() => handleEdit(todo)}
                  className="ml-5 cursor-pointer"
                  alt=""
                  src={icon_edit}
                />
              </div>
              <img
                data-cy="todo-item-delete-button"
                onClick={() => setDeleteTodo(todo)}
                src={icon_delete}
                className="ml-auto cursor-pointer"
                alt=""
              />
            </div>
          ))
        ) : (
          <div className="flex justify-center items-center mt-8">
            <TodoEmpty />
          </div>
        )}
      </div>
      {isDelete && (
        <DeleteItem
          item={deleteTodoItem}
          isModal={isDelete}
          destroy={handleDelete}
          reset={handleBack}
        />
      )}
    </>
  );
}

export default ListItems;
